// getQuoteData
import * as React from 'react';
import { useState } from 'react';


import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const QUOTE_COLLAPSE_LENGTH = 75;


export default function CollapsibleTypographyCanvasPopup(props: any) {
    const [isExpanded, setIsExpanded] = useState(false);
    const quouteCollapseLength =
        props?.quouteCollapseLength || QUOTE_COLLAPSE_LENGTH;
    const incomingQuote = props?.quote;
    const renderDecoration = props?.quoteDecoration;
    const incomingFontStyle = props?.fontStyle ? props?.fontStyle : 'italic';
    const theme = useTheme();
    let renderableQuoteCache = incomingQuote;
    let quoteSize = renderableQuoteCache ? renderableQuoteCache?.length : 0;
    const containerRef = React.useRef<HTMLDivElement | null>(null);

    try {
        renderableQuoteCache = incomingQuote;
        quoteSize = renderableQuoteCache?.length;
    } catch (e) {

    }
    
    React.useEffect(() => {
        if (containerRef.current) {
              props.updatePopupHeight(Math.random());
        }
    }, [isExpanded]);

    const coreTypography = <Typography sx={{ fontStyle: incomingFontStyle,display:"inline" }}
       onClick={() => {
         if(props.isComment===undefined && props.routeToInsight!==undefined){
           props.routeToInsight();
         }
       }}
    >
        {
            props.isComment ? <strong>Comment : </strong> : <strong>Quote : </strong>
        }
        {`${renderDecoration}${renderableQuoteCache}${renderDecoration}`}
        <Box
            component="span"
            onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
            }}
            sx={{
            fontWeight: "bold",
            color: "primary.main",
            ml: 1,
            cursor: "pointer",
            }}
        >
            {isExpanded ? "Read less" : "...Read more"}
        </Box>
    </Typography>

    if (quoteSize < quouteCollapseLength) {
        return <Stack 
            onClick={()=>{if(props.isComment===undefined){ props.routeToInsight();  }}}
        >
            {coreTypography}
        </Stack>
    }
    else {
        return (
            <Box
                ref={containerRef}
                className="CollapsibleTypography"
                onClick={() => {
                    if(props.isComment){
                        setIsExpanded(!isExpanded);
                    }
                }}
                sx={{
                    color: "inherit",
                    ":hover": {
                        color: !props?.isComment && theme?.custom?.mainButtonHighlight,
                        textDecoration: !props?.isComment && "underline",
                        cursor: "pointer",
                    },
                }}
            >
                {isExpanded ? (
                   coreTypography
                ) : (
                    <Typography sx={{ fontStyle: incomingFontStyle, display: "inline" }} onClick={() => {
                          if(props.isComment===undefined && props.routeToInsight!==undefined){
                            props.routeToInsight();
                      }
                    }}>
                        {
                           props.isComment ? <strong>Comment : </strong> : <strong>Quote : </strong>
                        }
                        {`${renderDecoration}${renderableQuoteCache?.slice(
                            0,
                            quouteCollapseLength
                        )}${renderDecoration}`}
                         <Box
                            component="span"
                            onClick={(e) => {
                            e.stopPropagation();
                            setIsExpanded(!isExpanded);
                            }}
                            sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            ml: 1,
                            cursor: "pointer",
                            }}
                        >
                            {isExpanded ? "Read less" : "...Read more"}
                        </Box>
                    </Typography>
                )}
            </Box>
        );
    }
}
